import styled from 'styled-components';

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  column-gap: 64px;
  flex-wrap: wrap;
  row-gap: 32px;

  &.btns-wrapper {
    align-items: flex-end;
    @media ${(props) => props.theme.device.mobileL} {
      gap: 16px;
    }
  }

  .set-hours {
    align-items: flex-end;
    gap: 16px;

    > svg {
      margin-bottom: 8px;
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;

    > div {
      width: 100%;
    }
  }
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${(props) => props.theme.colors.btnDisabledBg};
  margin: 40px auto;
`;
